export const ASSIGNMENT_OWNED_EMPLOYEE_FIELD_KEYS = ['module', 'mode_scope'];

export const excludeAssignmentOwnedEmployeeFields = (fields = []) => fields.filter(
  field => !ASSIGNMENT_OWNED_EMPLOYEE_FIELD_KEYS.includes(field?.key || field?.slug)
);
